/* eslint-disable import/order */
// deps
import { amountOptions, discountMinimumValue } from "constants/giftcard";
import React, { useMemo, useContext, useCallback } from "react";

import { AnalyticsEventContext, SwiggyHeadersContext, RouterContext } from "@swiggy-private/swiggy-money-context/src";
import GiftCardSelection from "@swiggy-private/swiggy-money-ui/src/GiftCardSelection";

import { getAnalyticsEvents } from "analytics";
import { getGiftCardAnalyticsEvents } from "analytics/giftcard";
import { HeadTag } from "components/Head";
import { useLogin } from "hooks/useLogin";
import type { NextPage } from "next";

// utils
import { Container, Main } from "styles/home";
import { initBridgeSdk } from "utils/bridgeSdk";
import { closeWebView, webNavigate } from "utils/NativeBridge";

// styles
import { getCurrentGiftingCardConfig } from "utils/utils";

const GiftSelection: NextPage = () => {
    const { swiggyHeaders, dynamicFlags } = useContext(SwiggyHeadersContext);
    const { router, isPreviousPathExists } = useContext(RouterContext);
    const sdk = useMemo(() => initBridgeSdk(), []);
    const analyticsEvents = useMemo(
        () => getAnalyticsEvents(swiggyHeaders, dynamicFlags),
        [swiggyHeaders, dynamicFlags],
    );
    const analyticsContextValue = useMemo(() => getGiftCardAnalyticsEvents(analyticsEvents), [analyticsEvents]);

    useLogin();

    const onBackClick = useCallback(() => {
        if (!isPreviousPathExists) {
            closeWebView(sdk);
            return;
        }
        router.back();
    }, [isPreviousPathExists, router, sdk]);

    const currentCardConfig = getCurrentGiftingCardConfig();

    const webNavigateSdk = useCallback(
        (url: string, openAsExternal: boolean, showBack?: boolean) => {
            webNavigate(sdk, url, openAsExternal, showBack);
        },
        [sdk],
    );

    return (
        <Container>
            <HeadTag title="Select your gift" />
            <Main>
                <AnalyticsEventContext.Provider value={analyticsContextValue}>
                    <GiftCardSelection
                        amountOptions={amountOptions}
                        discount={currentCardConfig.discountPercentage}
                        discountMinimumValue={discountMinimumValue}
                        onBackClick={onBackClick}
                        cardBannerImageUrl={currentCardConfig.mainImageUrl}
                        webNavigateSdk={webNavigateSdk}
                        defaultMessagePlaceholder={currentCardConfig.defaultMessagePlaceholder}
                    />
                </AnalyticsEventContext.Provider>
            </Main>
        </Container>
    );
};

export default GiftSelection;
